import { AnyAction } from 'redux';
import {
  GET_Countries_SUCCESS,
  GET_TOGGLER_SUCCESS,
  nationaliyType,
  togglerType,
} from '../types/mdms';
import { LOGOUT_SUCCESS } from '../types/auth';
import {
  CREATE_APPLICATION_SUCCESS,
  GET_ALL_APPLICATION_SUCCESS,
  GET_Documents_SUCCESS,
  GET_Fatca_SUCCESS,
} from '../types/application';
import { Document, FatcaMdms } from '../types/api-types';

export type mdmsProp = {
  Fatca: FatcaMdms;
  toggler: togglerType;
  countries: nationaliyType;
  Document: Document;
};

const InitialDocument: Document = {
  individual: [],
  individual_poa: [],
  corporate: [],
  trust: [],
  partnership_firm: [],
  huf: [],
  govt_bodies: [],
  registered_society: [],
  fii_fpi: [],
  bank_institutional_investor: [],
  unincorporated_or_body_of_individuals: [],
  foreign_entity: [],
  corporate_poa: [],
  trust_poa: [],
  partnership_firm_poa: [],
  huf_poa: [],
  govt_bodies_poa: [],
  registered_society_poa: [],
  fii_fpi_poa: [],
  bank_institxutional_investor_poa: [],
  unincorporated_or_body_of_individuals_poa: [],
  foreign_entity_poa: [],
};

const initialState: mdmsProp = {
  Fatca: {
    fatca_questions: [],
  },
  toggler: {
    dateFeatureToggles: {
      fatca_validation_date: '',
      tin_declaration_validation_date: '',
      npo_validation_date: '',
      accredidation_Validation_Date: '',
      excuseExclusionValidationDate: '',
      nomineeRemovalAndDeclarationValidationDate: '',
      qibChecklistValidationDate: '',
    },
    fatcaMasterDataFeatureToggle: {},
  },
  countries: {
    countries: [],
  },
  Document: InitialDocument,
};

export const mdmsDataReducer = (state = initialState, action: AnyAction): mdmsProp => {
  switch (action.type) {
    case GET_Fatca_SUCCESS:
      return { ...state, Fatca: action.body };
    case LOGOUT_SUCCESS:
    case GET_ALL_APPLICATION_SUCCESS:
    case CREATE_APPLICATION_SUCCESS: {
      return { ...initialState };
    }
    case GET_TOGGLER_SUCCESS: {
      return { ...state, toggler: action.body };
    }
    case GET_Documents_SUCCESS:
      return { ...state, Document: action.body };
    case GET_Countries_SUCCESS:
      return { ...state, countries: action.body };
    default:
      return state;
  }
};
